import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';

@Component({
    selector: 'app-load-factor',
    templateUrl: './load-factor.component.html',
    styleUrls: ['./load-factor.component.scss'],
    standalone: false
})
export class LoadFactorComponent implements OnChanges {

  @Input() loadFactor: number;
  public lf = [];
  public theme$: Observable<EThemeName>;

  constructor(private themeService: ThemeService) {
    this.theme$ = this.themeService.getTheme();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.lf = [];
    const loadFactor = changes.loadFactor.currentValue;
    if (loadFactor >= 100) {
      this.lf.push(180);
      this.lf.push(180);
    } else if (loadFactor <= 0) {
      this.lf.push(0);
    } else if (loadFactor > 50) {
      this.lf.push(180);
      this.lf.push((360 * (this.loadFactor - 50)) / 100);
    } else if (loadFactor <= 50) {
      this.lf.push((360 * this.loadFactor) / 100);
    }
  }

}
